import React from 'react';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';
import './Footer.css';
import footerlogo from '../assets/images/footer-logo.png';
import socialOne from '../assets/images/social-one.png';
import socialTwo from '../assets/images/social-two.png';
import socialThree from '../assets/images/social-three.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Team', href: '#team' },
      { name: 'Careers', href: '#careers' },
      { name: 'Press', href: '#press' }
    ],
    services: [
      { name: 'Yacht Charter', href: '#charter' },
      { name: 'Destinations', href: '#destinations' },
      { name: 'Events', href: '#events' },
      { name: 'Corporate', href: '#corporate' }
    ],
    support: [
      { name: 'Help Center', href: '#help' },
      { name: 'Contact Us', href: '#contact' },
      { name: 'Safety', href: '#safety' },
      { name: 'FAQ', href: '#faq' }
    ],
    legal: [
      { name: 'Terms of Service', href: '#terms' },
      { name: 'Privacy Policy', href: '#privacy' },
      { name: 'Cookie Policy', href: '#cookies' },
      { name: 'GDPR', href: '#gdpr' }
    ]
  };

  const socialLinks = [
    { icon: <img src={socialOne} alt="Facebook" />, href: '#', label: 'Facebook' },
    { icon: <img src={socialTwo} alt="Twitter" />, href: '#', label: 'Twitter' },
    { icon: <img src={socialThree} alt="Instagram" />, href: '#', label: 'Instagram' }
  ];

  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-top">
              <div className="footer-newsletter-text">
                 <p>Join our newsletter</p>
                 <p>Keep up to date</p>
          
              </div>
              <div className="footer-newsletter-input">
                <div className="footer-newsletter-input-container">
                  <input type="email" placeholder="User Email" className="footer-newsletter-input-field" />
                  <button className="footer-newsletter-input-button">Subscribe</button>
                </div>
                <div className="footer-newsletter-input-container">
                  <input type="email" placeholder="Advertise Email" className="footer-newsletter-input-field" />
                  <button className="footer-newsletter-input-button">Subscribe</button>
                </div>
                <div className="footer-newsletter-input-container">
                  <input type="email" placeholder="Community Email" className="footer-newsletter-input-field" />
                  <button className="footer-newsletter-input-button">Subscribe</button>
                </div>
                <div className="footer-newsletter-input-container">
                  <input type="email" placeholder="Investor Email " className="footer-newsletter-input-field" />
                  <button className="footer-newsletter-input-button">Subscribe</button>
                </div>
               
              </div>
        </div>
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src={footerlogo} alt="Nautio Logo" className="footer-logo"/>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <img src={socialOne} alt="Facebook" />
              </div>
              <div className="contact-item">
                <img src={socialTwo} alt="Twitter" />
              </div>
              <div className="contact-item">
                <img src={socialThree} alt="Instagram" />
              </div>
            </div>
          </div>
       
          {/* Footer Links */}
          <div className="footer-links">
            <div className="link-group">
              <h4>Get Support</h4>
               <p><a href="mailto:support@nautio.com" style={{color: '#EFEDFD', opacity: '60%', textDecoration: 'underline', fontSize: '14px'}}>support@nautio.com</a></p>
               <p><a href="tel:+15551234567" style={{color: '#EFEDFD', opacity: '60%', fontSize: '14px'}}>+41 58 680 6800</a></p>
            </div>
            <div className="link-group">
              <h4>Find Us</h4>
              <address style={{color: '#EFEDFD', opacity: '60%', fontSize: '14px'}}>Rigistrasse 3-Citypark <br />
                6300 Zug, Switzerland</address>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <a href="https://www.nautio.com" style={{color: 'rgba(239, 237, 253, 0.6)', fontSize: '14px', paddingRight: '12px', textDecoration: 'none'}}>Privacy Policy</a>
              <a href="https://www.nautio.com" style={{color: 'rgba(239, 237, 253, 0.6)', fontSize: '14px', paddingLeft: '12px', textDecoration: 'none'}}>Terms of Conditions</a>
            </div>
            
            <div className="social-links">
              <p style={{color: 'rgba(250, 250, 250, 0.6)', fontSize: '14px'}}>© DISEO 2019 -2025  | All rights reserved | CONFIDENTIAL</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 